import { pathToRegexp } from 'path-to-regexp';
export type TSlugifiedRoute = [string, RegExp];
export type TTemplateRouteDictionary = { default: Set<string>; slugified: TSlugifiedRoute[] };
export type TRoutesDictionary = Record<string, TTemplateRouteDictionary>;
export type TAvailableTemplates = keyof typeof ROUTES;
export const ROUTES: TRoutesDictionary = Object.freeze({
    '(content)/(hub)': {
        default: new Set<string>([
            'en',
            'en-ca',
            'en-ca/2024',
            'en-ca/about-adventure',
            'en-ca/about-casumo',
            'en-ca/android-app-guide',
            'en-ca/az-games',
            'en-ca/betting/soccer',
            'en-ca/bonus-terms',
            'en-ca/casino-games',
            'en-ca/casino-games/animal-slots',
            'en-ca/casino-games/beanstalk-grows-wild',
            'en-ca/casino-games/blackjack',
            'en-ca/casino-games/megaways-slots',
            'en-ca/casino-games/roulette',
            'en-ca/casino-games/slots',
            'en-ca/casino-games/slots/scatter-symbols',
            'en-ca/casino-games/slots/sticky-wilds',
            'en-ca/casino-guides',
            'en-ca/casino-guides/how-to-play-blackjack',
            'en-ca/casino-guides/how-to-play-roulette',
            'en-ca/casino-guides/how-to-play-slingo',
            'en-ca/casino-guides/how-to-play-slots',
            'en-ca/casino-guides/roulette-wheel',
            'en-ca/casino-riina',
            'en-ca/casino/slots/brand-slots',
            'en-ca/casumoverse-var',
            'en-ca/casumoverse-var-2',
            'en-ca/cookies-notice',
            'en-ca/evolution-gaming',
            'en-ca/fairness-statement',
            'en-ca/faq',
            'en-ca/forgot-password',
            'en-ca/game-browser',
            'en-ca/games/9-masks-of-fire-hyperspins',
            'en-ca/games/search',
            'en-ca/hall-of-fame',
            'en-ca/home',
            'en-ca/home-test',
            'en-ca/jackpots',
            'en-ca/jackpots/casumo-jackpots',
            'en-ca/join',
            'en-ca/l/aff/blackjack-roulette',
            'en-ca/l/aff/free-to-play',
            'en-ca/l/aff/live-casino',
            'en-ca/l/aff/slots',
            'en-ca/l/aff/top-game',
            'en-ca/l/aff/welcome-offer',
            'en-ca/l/tj',
            'en-ca/l/umo-days',
            'en-ca/l/welcome-offer',
            'en-ca/l/xmas-in-july',
            'en-ca/landing/adsterra',
            'en-ca/landing/casumo-jackpots',
            'en-ca/landing/q2-casino-wo',
            'en-ca/landing/q3-casino-wo',
            'en-ca/landing/roulette-q4-2023',
            'en-ca/landing/slots-q4-2023',
            'en-ca/landing/tj',
            'en-ca/landing/welcome-offer-q4-2023',
            'en-ca/landing/xmas-prize-pool',
            'en-ca/live-casino',
            'en-ca/live-casino-welcome-offer',
            'en-ca/live-casino/blackjack',
            'en-ca/live-casino/casumo-studio',
            'en-ca/live-casino/roulette',
            'en-ca/log-in',
            'en-ca/march-madness-2022',
            'en-ca/microgaming',
            'en-ca/migration-test',
            'en-ca/mobile-app',
            'en-ca/module-test-ny',
            'en-ca/module-test-xm',
            'en-ca/play-n-go',
            'en-ca/play-okay',
            'en-ca/playtech',
            'en-ca/pragmatic-play',
            'en-ca/privacy-notice',
            'en-ca/promotions',
            'en-ca/register',
            'en-ca/relax-gaming',
            'en-ca/restricted-territory-list',
            'en-ca/retention-policy',
            'en-ca/sbc-summit-2024',
            'en-ca/select-country',
            'en-ca/slots',
            'en-ca/special-promotions/golden-osiris',
            'en-ca/special-promotions/golden-osiris-campaign',
            'en-ca/terms-and-conditions',
            'en-ca/tournament-terms-and-conditions',
            'en-ca/verse',
            'en-ca/welcome-offer',
            'en-ca/withdrawal-policy',
            'en-ca/wo-terms',
            'en-gb',
            'en-gb/2024',
            'en-gb/about-adventure',
            'en-gb/about-casumo',
            'en-gb/android-app-guide',
            'en-gb/az-games',
            'en-gb/betting/cricket',
            'en-gb/betting/football',
            'en-gb/bonus-terms',
            'en-gb/casino-bonus',
            'en-gb/casino-games',
            'en-gb/casino-games/animal-slots',
            'en-gb/casino-games/beanstalk-grows-wild',
            'en-gb/casino-games/blackjack',
            'en-gb/casino-games/dead-or-alive-saloon',
            'en-gb/casino-games/lightning-roulette',
            'en-gb/casino-games/lightning-roulette-extreme',
            'en-gb/casino-games/megapays',
            'en-gb/casino-games/roulette',
            'en-gb/casino-games/slots',
            'en-gb/casino-games/slots/scatter-symbols',
            'en-gb/casino-games/slots/sticky-wilds',
            'en-gb/casino-guides',
            'en-gb/casino-guides/how-to-play-blackjack',
            'en-gb/casino-guides/how-to-play-roulette',
            'en-gb/casino-guides/how-to-play-slingo',
            'en-gb/casino-guides/how-to-play-slots',
            'en-gb/casino-guides/roulette-wheel',
            'en-gb/casino-riina',
            'en-gb/casino/slots/brand-slots',
            'en-gb/casumo-trivia-promo-terms',
            'en-gb/casumoverse-var-2',
            'en-gb/casumoverse-var2',
            'en-gb/complaints-procedure',
            'en-gb/cookies-notice',
            'en-gb/dream-cash-drop-promo-terms',
            'en-gb/euro-2024-betting-guide',
            'en-gb/euro-2024-betting-guide-round-of-16',
            'en-gb/euro-2024-betting-strategies',
            'en-gb/euro-2024-explained',
            'en-gb/euro-2024-final-betting-guide',
            'en-gb/euro-2024-group-a-guide',
            'en-gb/euro-2024-group-b-guide',
            'en-gb/euro-2024-group-c-guide',
            'en-gb/euro-2024-group-d-guide',
            'en-gb/euro-2024-group-e-guide',
            'en-gb/euro-2024-group-f-guide',
            'en-gb/euro-2024-post-final-review',
            'en-gb/euro-2024-quarter-finals-betting-guide',
            'en-gb/euro-2024-semi-finals-betting-guide',
            'en-gb/evolution-gaming',
            'en-gb/fairness-statement',
            'en-gb/faq',
            'en-gb/forgot-password',
            'en-gb/game-browser',
            'en-gb/games/search',
            'en-gb/gem-drops-promo-terms',
            'en-gb/hall-of-fame',
            'en-gb/home',
            'en-gb/home-test',
            'en-gb/jackpots',
            'en-gb/jackpots/casumo-jackpots',
            'en-gb/join',
            'en-gb/l/aff/blackjack',
            'en-gb/l/aff/blackjack-roulette',
            'en-gb/l/aff/blackjack-roulette/pick-play',
            'en-gb/l/aff/blackjack-roulette/topcasinosuk',
            'en-gb/l/aff/live-casino',
            'en-gb/l/aff/live-casino/10bestcasinos',
            'en-gb/l/aff/live-casino/pick-play',
            'en-gb/l/aff/live-casino/topcasinosuk',
            'en-gb/l/aff/slots',
            'en-gb/l/aff/slots/pick-play',
            'en-gb/l/aff/slots/superfreeslotgames',
            'en-gb/l/aff/slots/topcasinosuk',
            'en-gb/l/aff/top-game',
            'en-gb/l/aff/top-game/10-best-casinos',
            'en-gb/l/aff/top-game/pick-play',
            'en-gb/l/aff/top-game/top-casinos-uk',
            'en-gb/l/aff/welcome-offer',
            'en-gb/l/aff/welcome-offer/10bestcasinos',
            'en-gb/l/aff/welcome-offer/top10casinos',
            'en-gb/l/aff/welcome-offer/topcasinosuk',
            'en-gb/l/australian-open',
            'en-gb/l/betting',
            'en-gb/l/betting-site',
            'en-gb/l/blackjack-online',
            'en-gb/l/blackjack-online-b',
            'en-gb/l/casino',
            'en-gb/l/casino-bonus',
            'en-gb/l/casino-games',
            'en-gb/l/casino-site',
            'en-gb/l/football-betting',
            'en-gb/l/gambling-site',
            'en-gb/l/games/big-bass-bonanza',
            'en-gb/l/games/big-bass-splash',
            'en-gb/l/games/starburst',
            'en-gb/l/horse-racing',
            'en-gb/l/online-betting',
            'en-gb/l/online-casino',
            'en-gb/l/online-casino-b',
            'en-gb/l/online-roulette',
            'en-gb/l/online-slots',
            'en-gb/l/plinko',
            'en-gb/l/poker-online',
            'en-gb/l/roulette',
            'en-gb/l/slot-games',
            'en-gb/l/slots',
            'en-gb/l/slots-b',
            'en-gb/l/test',
            'en-gb/l/umo-days',
            'en-gb/l/welcome-offer',
            'en-gb/l/welcome-offer-b',
            'en-gb/l/xmas-in-july',
            'en-gb/landing/casumo-jackpots',
            'en-gb/landing/q2-casino-wo',
            'en-gb/landing/q3-casino-wo',
            'en-gb/landing/xmas-prize-pool',
            'en-gb/live-casino',
            'en-gb/live-casino-welcome-offer',
            'en-gb/live-casino/blackjack',
            'en-gb/live-casino/casumo-studio',
            'en-gb/live-casino/roulette',
            'en-gb/log-in',
            'en-gb/lp/odds',
            'en-gb/lp/slots',
            'en-gb/lucky-cards-promo-terms',
            'en-gb/mega-fire-blaze-roulette-live-promo-terms',
            'en-gb/microgaming',
            'en-gb/migration-test',
            'en-gb/mobile-app',
            'en-gb/module-test-ny',
            'en-gb/module-test-xm',
            'en-gb/play-n-go',
            'en-gb/play-okay',
            'en-gb/playtech',
            'en-gb/pragmatic-10k-promo-terms',
            'en-gb/pragmatic-play',
            'en-gb/privacy-notice',
            'en-gb/promotions',
            'en-gb/register',
            'en-gb/relax-gaming',
            'en-gb/retention-policy',
            'en-gb/sbc-summit-2024',
            'en-gb/select-country',
            'en-gb/slots',
            'en-gb/special-promotions/enh-wo-slots',
            'en-gb/special-promotions/golden-osiris',
            'en-gb/special-promotions/golden-osiris-campaign',
            'en-gb/special-promotions/wo-slots',
            'en-gb/terms-and-conditions',
            'en-gb/tournament-terms-and-conditions',
            'en-gb/verse',
            'en-gb/welcome-offer',
            'en-gb/withdrawal-policy',
            'en-gb/wo-terms',
            'en-gb/yggdrasil-prize-drops-terms',
            'en-nz',
            'en-nz/2024',
            'en-nz/about-adventure',
            'en-nz/about-casumo',
            'en-nz/android-app-guide',
            'en-nz/az-games',
            'en-nz/bonus-terms',
            'en-nz/casino-games',
            'en-nz/casino-games/animal-slots',
            'en-nz/casino-games/beanstalk-grows-wild',
            'en-nz/casino-games/blackjack',
            'en-nz/casino-games/dead-or-alive-saloon',
            'en-nz/casino-games/lightning-roulette',
            'en-nz/casino-games/lightning-roulette-extreme',
            'en-nz/casino-games/megapays',
            'en-nz/casino-games/megaways-slots',
            'en-nz/casino-games/roulette',
            'en-nz/casino-games/slots',
            'en-nz/casino-games/slots/scatter-symbols',
            'en-nz/casino-games/slots/sticky-wilds',
            'en-nz/casino-guides',
            'en-nz/casino-guides/how-to-play-blackjack',
            'en-nz/casino-guides/how-to-play-roulette',
            'en-nz/casino-guides/how-to-play-slots',
            'en-nz/casino-riina',
            'en-nz/casino/slots/brand-slots',
            'en-nz/casumoverse-var',
            'en-nz/casumoverse-var-2',
            'en-nz/cookies-notice',
            'en-nz/evolution-gaming',
            'en-nz/fairness-statement',
            'en-nz/faq',
            'en-nz/forgot-password',
            'en-nz/game-browser',
            'en-nz/games/search',
            'en-nz/hall-of-fame',
            'en-nz/home',
            'en-nz/home-test',
            'en-nz/jackpots',
            'en-nz/jackpots/casumo-jackpots',
            'en-nz/join',
            'en-nz/l/aff/big-bass-bonanza',
            'en-nz/l/aff/blackjack-roulette',
            'en-nz/l/aff/book-of-dead',
            'en-nz/l/aff/free-to-play',
            'en-nz/l/aff/live-casino',
            'en-nz/l/aff/slots',
            'en-nz/l/aff/top-game',
            'en-nz/l/aff/welcome-offer',
            'en-nz/l/tj',
            'en-nz/l/welcome-offer',
            'en-nz/l/xmas-in-july',
            'en-nz/landing/casumo-jackpots',
            'en-nz/landing/prop',
            'en-nz/landing/q2-casino-wo',
            'en-nz/landing/q3-23-ps-book-of-dead',
            'en-nz/landing/q3-23-ps-casumo-jackpots',
            'en-nz/landing/q3-23-ps-mega-moolah',
            'en-nz/landing/q3-casino-wo',
            'en-nz/landing/tj',
            'en-nz/landing/xmas-prize-pool',
            'en-nz/live-casino',
            'en-nz/live-casino/blackjack',
            'en-nz/live-casino/casumo-studio',
            'en-nz/live-casino/roulette',
            'en-nz/log-in',
            'en-nz/migration-test',
            'en-nz/mobile-app',
            'en-nz/module-test-ny',
            'en-nz/module-test-xm',
            'en-nz/play-n-go',
            'en-nz/play-okay',
            'en-nz/playtech',
            'en-nz/pragmatic-play',
            'en-nz/privacy-notice',
            'en-nz/promotions',
            'en-nz/register',
            'en-nz/relax-gaming',
            'en-nz/restricted-territory-list',
            'en-nz/retention-policy',
            'en-nz/sbc-summit-2024',
            'en-nz/select-country',
            'en-nz/slots',
            'en-nz/special-promotions/golden-osiris',
            'en-nz/special-promotions/golden-osiris-campaign',
            'en-nz/terms-and-conditions',
            'en-nz/tournament-terms-and-conditions',
            'en-nz/ugliest-catch-winner',
            'en-nz/verse',
            'en-nz/welcome-offer',
            'en-nz/welcome-offer-smp',
            'en-nz/withdrawal-policy',
            'en-nz/wo-terms',
            'en/2024',
            'en/about-adventure',
            'en/about-casumo',
            'en/android-app-guide',
            'en/az-games',
            'en/bonus-terms',
            'en/casino-games',
            'en/casino-games/animal-slots',
            'en/casino-games/beanstalk-grows-wild',
            'en/casino-games/blackjack',
            'en/casino-games/egypt-slots',
            'en/casino-games/fruit-slots',
            'en/casino-games/jackpot-slots',
            'en/casino-games/lightning-roulette',
            'en/casino-games/lightning-roulette-extreme',
            'en/casino-games/megapays',
            'en/casino-games/megaways-slots',
            'en/casino-games/roulette',
            'en/casino-games/slots',
            'en/casino-games/slots/scatter-symbols',
            'en/casino-games/slots/sticky-wilds',
            'en/casino-guides',
            'en/casino-guides/blackjack-strategy',
            'en/casino-guides/how-to-play-blackjack',
            'en/casino-guides/how-to-play-roulette',
            'en/casino-guides/how-to-play-slots',
            'en/casino-guides/roulette-wheel',
            'en/casino-riina',
            'en/casino/slots/brand-slots',
            'en/casumoverse-var',
            'en/casumoverse-var-2',
            'en/cookies-notice',
            'en/danny',
            'en/evolution-gaming',
            'en/fairness-statement',
            'en/faq',
            'en/forgot-password',
            'en/games/search',
            'en/hall-of-fame',
            'en/home',
            'en/home-banner-test',
            'en/jackpots',
            'en/jackpots/casumo-jackpots',
            'en/join',
            'en/l/aff/slots',
            'en/l/aff/top-game',
            'en/l/aff/welcome-offer',
            'en/l/australian-open',
            'en/l/welcome-offer',
            'en/landing/casino-wo_b',
            'en/landing/q2-casino-wo',
            'en/landing/q3-casino-wo',
            'en/landing/xmas-prize-pool',
            'en/live-casino',
            'en/live-casino/blackjack',
            'en/live-casino/casumo-studio',
            'en/live-casino/roulette',
            'en/log-in',
            'en/logged-in',
            'en/logged-in-out',
            'en/logged-out',
            'en/market-closure-2',
            'en/microgaming',
            'en/migration-test',
            'en/miguel-test/deposit',
            'en/mobile-app',
            'en/module-test-ny',
            'en/module-test-xm',
            'en/play-n-go',
            'en/play-okay',
            'en/playtech',
            'en/pragmatic-play',
            'en/privacy-notice',
            'en/promotions',
            'en/register',
            'en/relax-gaming',
            'en/restricted-territory-list',
            'en/retention-policy',
            'en/sbc-summit-2024',
            'en/select-country',
            'en/slots',
            'en/special-promotions/brand-diwali',
            'en/special-promotions/enh-wo-slots',
            'en/special-promotions/golden-osiris',
            'en/special-promotions/golden-osiris-campaign',
            'en/special-promotions/wo-slots',
            'en/standard-colours',
            'en/template',
            'en/terms-and-conditions',
            'en/testhomepage',
            'en/tournament-terms-and-conditions',
            'en/verse',
            'en/welcome-offer',
            'en/withdrawal-policy',
            'en/wo-terms',
            'es',
            'es/2024',
            'es/about-adventure',
            'es/android-app-guide',
            'es/app-movil',
            'es/aviso-privacidad',
            'es/az-games',
            'es/bizum-banner-test',
            'es/blackjack',
            'es/buscador-de-juegos',
            'es/casino-en-vivo',
            'es/casino-en-vivo/ruleta',
            'es/casino-guias',
            'es/casino-guias/como-jugar-blackjack',
            'es/casino-guias/como-jugar-ruleta',
            'es/casino-guias/como-jugar-slots',
            'es/casino-juegos',
            'es/casino-juegos/ruleta-relampago',
            'es/casino-juegos/slots/animales',
            'es/casino-juegos/slots/megaways',
            'es/casino-juegos/slots/simbolos-scatter',
            'es/casino-juegos/slots/sticky-wilds',
            'es/casino-juegos/slots/vikingos',
            'es/casino-juegos/tragaperras',
            'es/casino-riina',
            'es/casino/slots/brand-slots',
            'es/casumoverse-var-2',
            'es/casumoverse-var2',
            'es/contrasena-olvidada',
            'es/cookies-notice',
            'es/deportes-apuestas',
            'es/deportes-apuestas/futbol',
            'es/deportes-apuestas/futbol/copa-del-mundo',
            'es/deportes-apuestas/futbol/copa-del-mundo/balon-oro-cuotas',
            'es/deportes-apuestas/futbol/copa-del-mundo/bota-oro-cuotas',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuartos-final-cuotas',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-final',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-ganador',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-a',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-b',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-c',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-d',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-e',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-f',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-g',
            'es/deportes-apuestas/futbol/copa-del-mundo/cuotas-grupos/grupo-h',
            'es/deportes-apuestas/futbol/copa-del-mundo/guante-oro-cuotas',
            'es/deportes-apuestas/futbol/copa-del-mundo/octavos-final-cuotas',
            'es/deportes-apuestas/futbol/copa-del-mundo/semifinal-cuotas',
            'es/deportes-apuestas/tenis',
            'es/deportes-apuestas/ufc',
            'es/deprtes-terminos-y-condiciones',
            'es/espana-gana-euro2024-resumen-de-torneo',
            'es/euro-2024-estrategias-apuestas',
            'es/euro-2024-explicado',
            'es/euro-2024-finales-guia-de-apuesta',
            'es/euro-2024-group-a-guide',
            'es/euro-2024-group-b-guide',
            'es/euro-2024-group-c-guide',
            'es/euro-2024-group-d-guide',
            'es/euro-2024-group-e-guide',
            'es/euro-2024-group-f-guide',
            'es/euro-2024-guia-apuestas',
            'es/euro-2024-guia-de-apuesta-cuatros',
            'es/euro-2024-guia-de-apuesta-octavos',
            'es/euro-2024-semifinales-guia-de-apuesta',
            'es/evolution-gaming',
            'es/fairness-statement',
            'es/hall-of-fame',
            'es/home',
            'es/home-test',
            'es/iniciar-sesion',
            'es/join',
            'es/juega-bien',
            'es/juega-blackjack-casumo-casino',
            'es/juega-ruleta',
            'es/juegos/busqueda',
            'es/l/aff/blackjack-roulette',
            'es/l/aff/live-casino',
            'es/l/aff/slots',
            'es/l/aff/top-game',
            'es/l/aff/welcome-offer',
            'es/l/apuestas-deportivas',
            'es/l/australian-open',
            'es/l/blackjack-online',
            'es/l/bono-de-bienvenida',
            'es/l/casa-de-apuestas',
            'es/l/casino-online',
            'es/l/casino-slots',
            'es/l/online-casino',
            'es/l/online-casino-b',
            'es/l/online-slots',
            'es/l/plinko',
            'es/l/ruleta-online',
            'es/l/slots',
            'es/l/tragaperras-online',
            'es/l/umo-days',
            'es/l/welcome-offer',
            'es/l/welcome-offer-b',
            'es/l/xmas-in-july',
            'es/landing/q2-casino-wo',
            'es/landing/q3-casino-wo',
            'es/landing/xmas',
            'es/migration-test',
            'es/module-test-ny',
            'es/module-test-xm',
            'es/play-n-go',
            'es/preguntas-frecuentes',
            'es/promociones',
            'es/register',
            'es/retention-policy',
            'es/rtp',
            'es/ruleta',
            'es/sbc-summit-2024',
            'es/slots',
            'es/sobre-casumo',
            'es/terminos-del-bono',
            'es/terminos-slot-races',
            'es/terminos-y-condiciones',
            'es/verse',
            'es/withdrawal-policy',
            'es/wo-terms',
            'fi',
            'fi/2024',
            'fi/about-adventure',
            'fi/android-app-ohje',
            'fi/az-games',
            'fi/blackjack-opas',
            'fi/blackjack-opas/aloittelijan-opas-pelin-hallitsemiseen',
            'fi/blackjack-opas/blackjack-korttien-arvojen-ymmartaminen',
            'fi/blackjack-opas/blackjack-strategioiden-ymmartaminen',
            'fi/blackjack-opas/blackjackin-todennakoisyyksien-ymmartaminen',
            'fi/blackjack-opas/kuinka-jakaa-blackjack-kortteja',
            'fi/blackjack-opas/kuinka-lyoda-vetoa-blackjackissa',
            'fi/bonanza-megaways-winner',
            'fi/bonus-terms',
            'fi/bye-kazoom-hello-casumo',
            'fi/casino-guides/how-to-play-blackjack',
            'fi/casino-guides/how-to-play-roulette',
            'fi/casino-riina',
            'fi/casumo-app',
            'fi/casumosta',
            'fi/casumoverse-var-2',
            'fi/casumoverse-var2',
            'fi/cookies-notice',
            'fi/erikoistarjoukset/golden-osiris',
            'fi/erikoistarjoukset/golden-osiris-campaign',
            'fi/fairness-statement',
            'fi/faq',
            'fi/forgot-password',
            'fi/hall-of-fame',
            'fi/home',
            'fi/home-test',
            'fi/join',
            'fi/kampanjat',
            'fi/kasinopeliopas',
            'fi/kasinopeliopas/slots',
            'fi/kasinopelit',
            'fi/kasinopelit/beanstalk-grows-wild',
            'fi/kasinopelit/megaways-slots',
            'fi/kasinopelit/roulette',
            'fi/kasinopelit/slots',
            'fi/kirjaudu-sisaan',
            'fi/l/aff/blackjack-roulette',
            'fi/l/aff/free-to-play',
            'fi/l/aff/live-casino',
            'fi/l/aff/live-casino/broidi',
            'fi/l/aff/live-casino/pottukoira',
            'fi/l/aff/slots',
            'fi/l/aff/top-game',
            'fi/l/aff/welcome-offer',
            'fi/l/welcome-offer',
            'fi/l/welcome-offer/briodi',
            'fi/l/xmas-in-july',
            'fi/landing/prop',
            'fi/landing/tj',
            'fi/landing/xmas-prize-pool',
            'fi/live-casino',
            'fi/live-casino/blackjack',
            'fi/live-casino/casumo-studio',
            'fi/live-casino/roulette',
            'fi/migration-test',
            'fi/pelit/haku',
            'fi/play-okay',
            'fi/register',
            'fi/restricted-territory-list',
            'fi/retention-policy',
            'fi/sbc-summit-2024',
            'fi/select-country',
            'fi/slots',
            'fi/terms-and-conditions',
            'fi/tietosuojailmoitus',
            'fi/tournament-terms-and-conditions',
            'fi/verse',
            'fi/withdrawal-policy',
            'fi/wo-terms',
            'ie',
            'ie/2024',
            'ie/about-adventure',
            'ie/about-casumo',
            'ie/android-app-guide',
            'ie/az-games',
            'ie/bonus-terms',
            'ie/casino-games',
            'ie/casino-games/beanstalk-grows-wild',
            'ie/casino-games/blackjack',
            'ie/casino-games/dead-or-alive-saloon',
            'ie/casino-games/egypt-slots',
            'ie/casino-games/fruit-slots',
            'ie/casino-games/megapays',
            'ie/casino-games/megaways-slots',
            'ie/casino-games/roulette',
            'ie/casino-games/slots',
            'ie/casino-games/slots/scatter-symbols',
            'ie/casino-games/slots/sticky-wilds',
            'ie/casino-guides',
            'ie/casino-guides/how-to-play-blackjack',
            'ie/casino-guides/how-to-play-roulette',
            'ie/casino-guides/how-to-play-slots',
            'ie/casino-guides/roulette-wheel',
            'ie/casino-riina',
            'ie/casino/slots/brand-slots',
            'ie/casumoverse-var-2',
            'ie/casumoverse-var2',
            'ie/cookies-notice',
            'ie/evolution-gaming',
            'ie/fairness-statement',
            'ie/faq',
            'ie/forgot-password',
            'ie/game-browser',
            'ie/games/search',
            'ie/hall-of-fame',
            'ie/home',
            'ie/home-test',
            'ie/jackpots',
            'ie/jackpots/casumo-jackpots',
            'ie/join',
            'ie/l/aff/slots',
            'ie/l/aff/top-game',
            'ie/l/aff/welcome-offer',
            'ie/l/horse-racing',
            'ie/l/welcome-offer',
            'ie/landing/q2-casino-wo',
            'ie/landing/q3-casino-wo',
            'ie/landing/xmas-prize-pool',
            'ie/live-casino',
            'ie/live-casino/blackjack',
            'ie/live-casino/casumo-studio',
            'ie/live-casino/roulette',
            'ie/log-in',
            'ie/lp/odds',
            'ie/lp/slots',
            'ie/microgaming',
            'ie/migration-test',
            'ie/mobile-app',
            'ie/module-test-ny',
            'ie/module-test-xm',
            'ie/play-n-go',
            'ie/play-okay',
            'ie/playtech',
            'ie/pragmatic-play',
            'ie/privacy-notice',
            'ie/promotions',
            'ie/register',
            'ie/relax-gaming',
            'ie/restricted-territory-list',
            'ie/retention-policy',
            'ie/sbc-summit-2024',
            'ie/select-country',
            'ie/slots',
            'ie/special-promotions/golden-osiris',
            'ie/special-promotions/golden-osiris-campaign',
            'ie/terms-and-conditions',
            'ie/test-new-casino',
            'ie/tournament-terms-and-conditions',
            'ie/welcome-offer',
            'ie/withdrawal-policy',
            'ie/wo-terms',
            'no',
            'no/2024',
            'no/about-adventure',
            'no/android-app-guide',
            'no/az-games',
            'no/bonus-terms',
            'no/casinospill',
            'no/casinospill/blackjack',
            'no/casinospill/blackjack-guide-og-regler',
            'no/casinospill/casino-guide',
            'no/casinospill/dead-or-alive-saloon',
            'no/casinospill/lightning-roulette-extreme',
            'no/casinospill/roulette',
            'no/casinospill/roulette-guide-og-regler',
            'no/casinospill/spilleautomat-guide',
            'no/casinospill/spilleautomater',
            'no/casinospill/spilleautomater/megaways',
            'no/casinospill/spilleautomater/scatter-symboler',
            'no/casinospill/spilleautomater/sticky-wilds',
            'no/casumoverse-var-2',
            'no/casumoverse-var2',
            'no/cookies-notice',
            'no/faq',
            'no/forgot-password',
            'no/game-browser',
            'no/games/search',
            'no/hall-of-fame',
            'no/home',
            'no/home-test',
            'no/jackpots',
            'no/jackpots/casumo-jackpots',
            'no/join',
            'no/kampanjer',
            'no/l/aff/slots',
            'no/landing/prop',
            'no/landing/tj',
            'no/landing/xmas-prize-pool',
            'no/live-casino',
            'no/live-casino/blackjack',
            'no/live-casino/roulette',
            'no/logg-inn',
            'no/migration-test',
            'no/mobilcasino-app',
            'no/module-test-ny',
            'no/module-test-xm',
            'no/odds-betting/fotboll/serie-a',
            'no/oddsspill',
            'no/oddsspill/asian-handicap',
            'no/oddsspill/fotball/vm',
            'no/oddsspill/fotball/vm/attendedelsfinale-odds',
            'no/oddsspill/fotball/vm/beste-keeper',
            'no/oddsspill/fotball/vm/beste-spiller',
            'no/oddsspill/fotball/vm/finale-odds',
            'no/oddsspill/fotball/vm/gruppe-a',
            'no/oddsspill/fotball/vm/gruppe-b',
            'no/oddsspill/fotball/vm/gruppe-c',
            'no/oddsspill/fotball/vm/gruppe-d',
            'no/oddsspill/fotball/vm/gruppe-e',
            'no/oddsspill/fotball/vm/gruppe-f',
            'no/oddsspill/fotball/vm/gruppe-g',
            'no/oddsspill/fotball/vm/gruppe-h',
            'no/oddsspill/fotball/vm/grupper',
            'no/oddsspill/fotball/vm/kvartfinale-odds',
            'no/oddsspill/fotball/vm/odds-toppscorer',
            'no/oddsspill/fotball/vm/semifinale-odds',
            'no/oddsspill/fotball/vm/vinner-odds',
            'no/oddsspill/ishockey',
            'no/oddsspill/nhl',
            'no/oddsspill/virtuell-sport',
            'no/om-casumo',
            'no/personvernerklaeringen',
            'no/play-okay',
            'no/restricted-territory-list',
            'no/sbc-summit-2024',
            'no/select-country',
            'no/slots',
            'no/spesielle-kampanjer/golden-osiris',
            'no/spesielle-kampanjer/golden-osiris-campaign',
            'no/terms-and-conditions',
            'no/tournament-terms-and-conditions',
            'no/verse',
            'no/welcome-offer',
            'no/withdrawal-policy',
            'no/wo-terms',
            'on',
            'on/2024',
            'on/about-adventure',
            'on/about-casumo',
            'on/android-app-guide',
            'on/bonus-terms',
            'on/casino-games',
            'on/casino-games/beanstalk-grows-wild',
            'on/casino-games/blackjack',
            'on/casino-games/lightning-roulette-extreme',
            'on/casino-games/megaways-slots',
            'on/casino-games/roulette',
            'on/casino-games/slots',
            'on/casino-guides/how-to-play-blackjack',
            'on/casino-riina',
            'on/casino/slots/brand-slots',
            'on/casumo-trivia-promo-terms',
            'on/casumoverse-var-2',
            'on/casumoverse-var2',
            'on/cookies-notice',
            'on/dinopolis-winner',
            'on/fairness-statement',
            'on/faq',
            'on/forgot-password',
            'on/game-browser',
            'on/games',
            'on/games/9-masks-of-fire-hyperspins',
            'on/games/search',
            'on/hall-of-fame',
            'on/home',
            'on/home-test',
            'on/join',
            'on/l/aff/blackjack-roulette',
            'on/l/aff/free-to-play',
            'on/l/aff/live-casino',
            'on/l/aff/live-casino/10bestcasinos',
            'on/l/aff/live-casino/top-10-casinos',
            'on/l/aff/live-casino/top10casinos',
            'on/l/aff/slots',
            'on/l/aff/top-game',
            'on/l/aff/welcome-offer',
            'on/l/aff/welcome-offer/10bestcasinos',
            'on/l/aff/welcome-offer/top-10-casinos',
            'on/l/aff/welcome-offer/top10casinos',
            'on/l/online-casino',
            'on/l/slots',
            'on/l/umo-days',
            'on/l/welcome-offer',
            'on/l/xmas-in-july',
            'on/landing/adsterra',
            'on/landing/q2-casino-wo',
            'on/landing/q3-casino-wo',
            'on/landing/roulette-q4-2023',
            'on/landing/slots-q4-2023',
            'on/landing/tj',
            'on/landing/welcome-offer-q4-2023',
            'on/landing/xmas-prize-pool',
            'on/live-casino',
            'on/live-casino/blackjack',
            'on/live-casino/roulette',
            'on/log-in',
            'on/lucky-cards-promo-terms',
            'on/mega-fire-blaze-roulette-live-promo-terms',
            'on/migration-test',
            'on/mobile-app',
            'on/module-test-ny',
            'on/module-test-xm',
            'on/play-okay',
            'on/pragmatic-10k-promo-terms',
            'on/privacy-notice',
            'on/promotions',
            'on/register',
            'on/restricted-territory-list',
            'on/retention-policy',
            'on/sbc-summit-2024',
            'on/select-country',
            'on/slots',
            'on/special-promotions/golden-osiris',
            'on/special-promotions/golden-osiris-campaign',
            'on/terms-and-conditions',
            'on/tournament-terms-and-conditions',
            'on/welcome-offer',
            'on/withdrawal-policy',
            'on/wo-terms',
            'rog',
            'rog/2024',
            'rog/about-casumo',
            'rog/az-games',
            'rog/bonus-terms',
            'rog/casino-games',
            'rog/casino-games/blackjack',
            'rog/casino-games/roulette',
            'rog/casino-games/slots',
            'rog/casino-riina',
            'rog/casumoverse-var-2',
            'rog/casumoverse-var2',
            'rog/fairness-statement',
            'rog/faq',
            'rog/forgot-password',
            'rog/game-browser',
            'rog/games/search',
            'rog/home',
            'rog/join',
            'rog/live-casino',
            'rog/live-casino/blackjack',
            'rog/live-casino/roulette',
            'rog/log-in',
            'rog/migration-test',
            'rog/play-okay',
            'rog/privacy-notice',
            'rog/promotions',
            'rog/retention-policy',
            'rog/sbc-summit-2024',
            'rog/select-country',
            'rog/slots',
            'rog/special-promotions/golden-osiris',
            'rog/special-promotions/golden-osiris-campaign',
            'rog/terms-and-conditions',
            'rog/tournament-terms-and-conditions',
            'rog/withdrawal-policy',
            'rog/wo-terms',
            'row',
            'row/2024',
            'row/about-casumo',
            'row/android-app-guide',
            'row/az-games',
            'row/bonus-terms',
            'row/casino-games',
            'row/casino-games/animal-slots',
            'row/casino-games/beanstalk-grows-wild',
            'row/casino-games/blackjack',
            'row/casino-games/dead-or-alive-saloon',
            'row/casino-games/egypt-slots',
            'row/casino-games/fruit-slots',
            'row/casino-games/lightning-roulette',
            'row/casino-games/lightning-roulette-extreme',
            'row/casino-games/megaways-slots',
            'row/casino-games/roulette',
            'row/casino-games/slots',
            'row/casino-games/slots/scatter-symbols',
            'row/casino-games/slots/sticky-wilds',
            'row/casino-guides',
            'row/casino-guides/how-to-play-blackjack',
            'row/casino-guides/how-to-play-roulette',
            'row/casino-guides/how-to-play-slots',
            'row/casino-riina',
            'row/casumoverse-var-2',
            'row/casumoverse-var2',
            'row/cookies-notice',
            'row/evolution-gaming',
            'row/fairness-statement',
            'row/faq',
            'row/forgot-password',
            'row/game-browser',
            'row/games/9-masks-of-fire-hyperspins',
            'row/games/search',
            'row/home',
            'row/home-test',
            'row/jackpots',
            'row/jackpots/casumo-jackpots',
            'row/join',
            'row/l/aff/slots',
            'row/l/aff/top-game',
            'row/l/aff/welcome-offer',
            'row/l/welcome-offer',
            'row/landing/q2-casino-wo',
            'row/landing/q3-casino-wo',
            'row/landing/xmas-prize-pool',
            'row/live-casino',
            'row/live-casino/blackjack',
            'row/live-casino/casumo-studio',
            'row/live-casino/roulette',
            'row/log-in',
            'row/migration-test',
            'row/mobile-app',
            'row/module-test-ny',
            'row/module-test-xm',
            'row/play-okay',
            'row/privacy-notice',
            'row/promotions',
            'row/restricted-territory-list',
            'row/retention-policy',
            'row/sbc-summit-2024',
            'row/select-country',
            'row/slots',
            'row/special-promotions/golden-osiris',
            'row/special-promotions/golden-osiris-campaign',
            'row/terms-and-conditions',
            'row/tournament-terms-and-conditions',
            'row/verse',
            'row/welcome-offer',
            'row/withdrawal-policy',
            'row/wo-terms',
            'sv',
            'sv/2024',
            'sv/android-app-guide',
            'sv/az-games',
            'sv/bonus-terms',
            'sv/bye-kazoom-hello-casumo',
            'sv/casino-riina',
            'sv/casino/slots/brand-slots',
            'sv/casinospel',
            'sv/casinospel/beanstalk-grows-wild',
            'sv/casinospel/blackjack',
            'sv/casinospel/blackjack-guide-och-regler',
            'sv/casinospel/casino-guide',
            'sv/casinospel/casino-guide/slingo-guide',
            'sv/casinospel/lightning-roulette',
            'sv/casinospel/lightning-roulette-extreme',
            'sv/casinospel/megapays',
            'sv/casinospel/roulette',
            'sv/casinospel/roulette-guide-och-regler',
            'sv/casinospel/slots',
            'sv/casinospel/slots-guide',
            'sv/casinospel/slots/megaways',
            'sv/casinospel/slots/scatter-symboler',
            'sv/casinospel/slots/sticky-wilds',
            'sv/casinospel/slots/svenska-slots',
            'sv/casinospel/spelautomater',
            'sv/casumoverse-var-2',
            'sv/casumoverse-var2',
            'sv/cookies-notice',
            'sv/evolution-gaming',
            'sv/fairness-statement',
            'sv/faq',
            'sv/forgot-password',
            'sv/hall-of-fame',
            'sv/home',
            'sv/home-test',
            'sv/integritetspolicy',
            'sv/jackpots',
            'sv/jackpots/casumo-jackpots',
            'sv/join',
            'sv/kampanjer',
            'sv/l/aff/blackjack-roulette',
            'sv/l/aff/blackjack-roulette/gentoo',
            'sv/l/aff/free-to-play',
            'sv/l/aff/live-casino',
            'sv/l/aff/slots',
            'sv/l/aff/slots/gentoo',
            'sv/l/aff/top-game',
            'sv/l/aff/welcome-offer',
            'sv/l/online-casino',
            'sv/l/slots',
            'sv/l/welcome-offer',
            'sv/landing/casumo-jackpots',
            'sv/landing/q2-casino-wo',
            'sv/landing/q3-casino-wo',
            'sv/live-casino',
            'sv/live-casino/blackjack',
            'sv/live-casino/casumo-studio',
            'sv/live-casino/roulette',
            'sv/lp/odds',
            'sv/lp/slots',
            'sv/microgaming',
            'sv/migration-test',
            'sv/mobilcasino-app',
            'sv/module-test-ny',
            'sv/module-test-xm',
            'sv/odds-betting',
            'sv/odds-betting/asian-handicap',
            'sv/odds-betting/fotboll/allsvenskan',
            'sv/odds-betting/fotboll/vm',
            'sv/odds-betting/fotboll/vm/attondelsfinal-odds',
            'sv/odds-betting/fotboll/vm/basta-malvakt',
            'sv/odds-betting/fotboll/vm/basta-spelare',
            'sv/odds-betting/fotboll/vm/final-odds',
            'sv/odds-betting/fotboll/vm/grupp-a',
            'sv/odds-betting/fotboll/vm/grupp-b',
            'sv/odds-betting/fotboll/vm/grupp-c',
            'sv/odds-betting/fotboll/vm/grupp-d',
            'sv/odds-betting/fotboll/vm/grupp-e',
            'sv/odds-betting/fotboll/vm/grupp-f',
            'sv/odds-betting/fotboll/vm/grupp-g',
            'sv/odds-betting/fotboll/vm/grupp-h',
            'sv/odds-betting/fotboll/vm/grupper',
            'sv/odds-betting/fotboll/vm/kvartsfinal-odds',
            'sv/odds-betting/fotboll/vm/semi-final-odds',
            'sv/odds-betting/fotboll/vm/skyttekung-odds',
            'sv/odds-betting/fotboll/vm/vinnar-odds',
            'sv/odds-betting/ishockey',
            'sv/odds-betting/ishockey/nhl',
            'sv/odds-betting/superbowl',
            'sv/odds-betting/virtuella-sporter',
            'sv/om-casumo',
            'sv/play-n-go',
            'sv/play-okay',
            'sv/playtech',
            'sv/pragmatic-play',
            'sv/register',
            'sv/relax-gaming',
            'sv/retention-policy',
            'sv/sbc-summit-2024',
            'sv/select-country',
            'sv/slots',
            'sv/special-kampanje/golden-osiris',
            'sv/special-kampanje/golden-osiris-kampanje',
            'sv/spel/9-masks-of-fire-hyperspins',
            'sv/spel/sokning',
            'sv/spelvaljare',
            'sv/terms-and-conditions',
            'sv/traditionell-inlogg',
            'sv/verse',
            'sv/welcome-offer',
            'sv/wo-terms'
        ]),
        slugified: [
            ['en-ca/accountblocked/:token/:pid', pathToRegexp('en-ca/accountblocked/:token/:pid')],
            [
                'en-ca/accountverification/:token/:pid',
                pathToRegexp('en-ca/accountverification/:token/:pid')
            ],
            ['en-ca/change-password/:ticketId', pathToRegexp('en-ca/change-password/:ticketId')],
            [
                'en-ca/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('en-ca/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['en-ca/play/:gameSlug', pathToRegexp('en-ca/play/:gameSlug')],
            [
                'en-ca/play/:gameSlugLocalizedENCA',
                pathToRegexp('en-ca/play/:gameSlugLocalizedENCA')
            ],
            ['en-ca/promotions/:promotionSlug', pathToRegexp('en-ca/promotions/:promotionSlug')],
            ['en-gb/accountblocked/:token/:pid', pathToRegexp('en-gb/accountblocked/:token/:pid')],
            [
                'en-gb/accountverification/:token/:pid',
                pathToRegexp('en-gb/accountverification/:token/:pid')
            ],
            ['en-gb/change-password/:ticketId', pathToRegexp('en-gb/change-password/:ticketId')],
            [
                'en-gb/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('en-gb/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['en-gb/play/:gameSlug', pathToRegexp('en-gb/play/:gameSlug')],
            [
                'en-gb/play/:gameSlugLocalizedENGB',
                pathToRegexp('en-gb/play/:gameSlugLocalizedENGB')
            ],
            ['en-gb/promotions/:promotionSlug', pathToRegexp('en-gb/promotions/:promotionSlug')],
            ['en-nz/accountblocked/:token/:pid', pathToRegexp('en-nz/accountblocked/:token/:pid')],
            [
                'en-nz/accountverification/:token/:pid',
                pathToRegexp('en-nz/accountverification/:token/:pid')
            ],
            ['en-nz/change-password/:ticketId', pathToRegexp('en-nz/change-password/:ticketId')],
            [
                'en-nz/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('en-nz/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['en-nz/play/:gameSlug', pathToRegexp('en-nz/play/:gameSlug')],
            [
                'en-nz/play/:gameSlugLocalizedENNZ',
                pathToRegexp('en-nz/play/:gameSlugLocalizedENNZ')
            ],
            ['en-nz/promotions/:promotionSlug', pathToRegexp('en-nz/promotions/:promotionSlug')],
            ['en/accountblocked/:token/:pid', pathToRegexp('en/accountblocked/:token/:pid')],
            [
                'en/accountverification/:token/:pid',
                pathToRegexp('en/accountverification/:token/:pid')
            ],
            ['en/change-password/:ticketId', pathToRegexp('en/change-password/:ticketId')],
            [
                'en/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('en/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['en/logged-in-slugified/:slug', pathToRegexp('en/logged-in-slugified/:slug')],
            ['en/play/:gameSlug', pathToRegexp('en/play/:gameSlug')],
            ['en/play/:gameSlugLocalizedEN', pathToRegexp('en/play/:gameSlugLocalizedEN')],
            ['en/promotions/:promotionSlug', pathToRegexp('en/promotions/:promotionSlug')],
            ['es/accountblocked/:token/:pid', pathToRegexp('es/accountblocked/:token/:pid')],
            [
                'es/accountverification/:token/:pid',
                pathToRegexp('es/accountverification/:token/:pid')
            ],
            ['es/cambio-contrasena/:ticketId', pathToRegexp('es/cambio-contrasena/:ticketId')],
            [
                'es/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('es/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['es/jugar/:gameSlug', pathToRegexp('es/jugar/:gameSlug')],
            ['es/jugar/:gameSlugLocalizedES', pathToRegexp('es/jugar/:gameSlugLocalizedES')],
            ['es/promociones/:promotionSlug', pathToRegexp('es/promociones/:promotionSlug')],
            ['es/test-template/:mySlug', pathToRegexp('es/test-template/:mySlug')],
            ['fi/accountblocked/:token/:pid', pathToRegexp('fi/accountblocked/:token/:pid')],
            [
                'fi/accountverification/:token/:pid',
                pathToRegexp('fi/accountverification/:token/:pid')
            ],
            ['fi/change-password/:ticketId', pathToRegexp('fi/change-password/:ticketId')],
            [
                'fi/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('fi/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['fi/kampanjat/:promotionSlug', pathToRegexp('fi/kampanjat/:promotionSlug')],
            ['fi/pelaa/:gameSlug', pathToRegexp('fi/pelaa/:gameSlug')],
            ['fi/pelaa/:gameSlugLocalizedFI', pathToRegexp('fi/pelaa/:gameSlugLocalizedFI')],
            ['ie/accountblocked/:token/:pid', pathToRegexp('ie/accountblocked/:token/:pid')],
            [
                'ie/accountverification/:token/:pid',
                pathToRegexp('ie/accountverification/:token/:pid')
            ],
            ['ie/change-password/:ticketId', pathToRegexp('ie/change-password/:ticketId')],
            [
                'ie/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('ie/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['ie/play/:gameSlug', pathToRegexp('ie/play/:gameSlug')],
            ['ie/play/:gameSlugLocalizedIE', pathToRegexp('ie/play/:gameSlugLocalizedIE')],
            ['ie/promotions/:promotionSlug', pathToRegexp('ie/promotions/:promotionSlug')],
            ['no/accountblocked/:token/:pid', pathToRegexp('no/accountblocked/:token/:pid')],
            [
                'no/accountverification/:token/:pid',
                pathToRegexp('no/accountverification/:token/:pid')
            ],
            ['no/change-password/:ticketId', pathToRegexp('no/change-password/:ticketId')],
            [
                'no/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('no/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['no/kampanjer/:promotionSlug', pathToRegexp('no/kampanjer/:promotionSlug')],
            ['no/spill/:gameSlug', pathToRegexp('no/spill/:gameSlug')],
            ['no/spill/:gameSlugLocalizedNO', pathToRegexp('no/spill/:gameSlugLocalizedNO')],
            ['on/accountblocked/:token/:pid', pathToRegexp('on/accountblocked/:token/:pid')],
            [
                'on/accountverification/:token/:pid',
                pathToRegexp('on/accountverification/:token/:pid')
            ],
            ['on/change-password/:ticketId', pathToRegexp('on/change-password/:ticketId')],
            [
                'on/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('on/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['on/play/:gameSlug', pathToRegexp('on/play/:gameSlug')],
            ['on/play/:gameSlugLocalizedON', pathToRegexp('on/play/:gameSlugLocalizedON')],
            ['on/promotions/:promotionSlug', pathToRegexp('on/promotions/:promotionSlug')],
            ['rog/accountblocked/:token/:pid', pathToRegexp('rog/accountblocked/:token/:pid')],
            [
                'rog/accountverification/:token/:pid',
                pathToRegexp('rog/accountverification/:token/:pid')
            ],
            ['rog/change-password/:ticketId', pathToRegexp('rog/change-password/:ticketId')],
            [
                'rog/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('rog/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['rog/play/:gameSlug', pathToRegexp('rog/play/:gameSlug')],
            ['rog/play/:gameSlugLocalizedROG', pathToRegexp('rog/play/:gameSlugLocalizedROG')],
            ['rog/promotions/:promotionSlug', pathToRegexp('rog/promotions/:promotionSlug')],
            ['row/accountblocked/:token/:pid', pathToRegexp('row/accountblocked/:token/:pid')],
            [
                'row/accountverification/:token/:pid',
                pathToRegexp('row/accountverification/:token/:pid')
            ],
            ['row/change-password/:ticketId', pathToRegexp('row/change-password/:ticketId')],
            [
                'row/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('row/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['row/play/:gameSlug', pathToRegexp('row/play/:gameSlug')],
            ['row/play/:gameSlugLocalizedROW', pathToRegexp('row/play/:gameSlugLocalizedROW')],
            ['row/promotions/:promotionSlug', pathToRegexp('row/promotions/:promotionSlug')],
            ['sv/accountblocked/:token/:pid', pathToRegexp('sv/accountblocked/:token/:pid')],
            [
                'sv/accountverification/:token/:pid',
                pathToRegexp('sv/accountverification/:token/:pid')
            ],
            ['sv/change-password/:ticketId', pathToRegexp('sv/change-password/:ticketId')],
            [
                'sv/email/verify/:playerId?/:emailVerificationCode?',
                pathToRegexp('sv/email/verify/:playerId?/:emailVerificationCode?')
            ],
            ['sv/kampanjer/:promotionSlug', pathToRegexp('sv/kampanjer/:promotionSlug')],
            ['sv/spela/:gameSlug', pathToRegexp('sv/spela/:gameSlug')],
            ['sv/spela/:gameSlugLocalizedSV', pathToRegexp('sv/spela/:gameSlugLocalizedSV')]
        ]
    },
    '(content)/(hub)/(play-games)': {
        default: new Set<string>([]),
        slugified: [
            ['en-ca/practise/:gameSlug', pathToRegexp('en-ca/practise/:gameSlug')],
            ['en-gb/practise/:gameSlug', pathToRegexp('en-gb/practise/:gameSlug')],
            ['en-nz/practise/:gameSlug', pathToRegexp('en-nz/practise/:gameSlug')],
            ['en/practise/:gameSlug', pathToRegexp('en/practise/:gameSlug')],
            ['es/practise/:gameSlug', pathToRegexp('es/practise/:gameSlug')],
            ['fi/practise/:gameSlug', pathToRegexp('fi/practise/:gameSlug')],
            ['ie/practise/:gameSlug', pathToRegexp('ie/practise/:gameSlug')],
            ['no/practise/:gameSlug', pathToRegexp('no/practise/:gameSlug')],
            ['on/practise/:gameSlug', pathToRegexp('on/practise/:gameSlug')],
            ['rog/practise/:gameSlug', pathToRegexp('rog/practise/:gameSlug')],
            ['row/practise/:gameSlug', pathToRegexp('row/practise/:gameSlug')],
            ['sv/practise/:gameSlug', pathToRegexp('sv/practise/:gameSlug')]
        ]
    },
    '(content)/(no-hub)': {
        default: new Set<string>([
            'en-ca/more',
            'en-gb/more',
            'en-nz/more',
            'en/more',
            'es/more',
            'fi/more',
            'ie/more',
            'no/more',
            'on/more',
            'rog/more',
            'row/more',
            'sv/more'
        ]),
        slugified: [
            [
                'es/cash/history/monthly-summary/:month',
                pathToRegexp('es/cash/history/monthly-summary/:month')
            ]
        ]
    },
    '(content)/(player-hub)': {
        default: new Set<string>([
            'en-ca/player',
            'en-ca/player/documents-verification',
            'en-ca/player/play-okay-settings',
            'en-ca/player/settings',
            'en-gb/player',
            'en-gb/player/documents-verification',
            'en-gb/player/play-okay-settings',
            'en-gb/player/settings',
            'en-nz/player',
            'en-nz/player/documents-verification',
            'en-nz/player/play-okay-settings',
            'en-nz/player/settings',
            'en/player',
            'en/player/documents-verification',
            'en/player/play-okay-settings',
            'en/player/settings',
            'es/profile',
            'es/profile/documents-verification',
            'es/profile/play-okay-settings',
            'es/profile/settings',
            'fi/player',
            'fi/player/documents-verification',
            'fi/player/play-okay-settings',
            'fi/player/settings',
            'ie/player',
            'ie/player/documents-verification',
            'ie/player/play-okay-settings',
            'ie/player/settings',
            'no/player',
            'no/player/documents-verification',
            'no/player/play-okay-settings',
            'no/player/settings',
            'on/player',
            'on/player/documents-verification',
            'on/player/play-okay-settings',
            'on/player/settings',
            'sv/player',
            'sv/player/documents-verification',
            'sv/player/play-okay-settings',
            'sv/player/settings'
        ]),
        slugified: []
    },
    '(content)/(sports-hub)': {
        default: new Set<string>([
            'en-ca/l/aff/sports',
            'en-ca/sports-betting',
            'en-ca/sports-betting/american-football',
            'en-ca/sports-betting/baseball',
            'en-ca/sports-betting/boxing',
            'en-ca/sports-betting/football/world-cup',
            'en-ca/sports-betting/football/world-cup/final-odds',
            'en-ca/sports-betting/football/world-cup/golden-ball-odds',
            'en-ca/sports-betting/football/world-cup/golden-boot-odds',
            'en-ca/sports-betting/football/world-cup/golden-glove-odds',
            'en-ca/sports-betting/football/world-cup/group-odds',
            'en-ca/sports-betting/football/world-cup/group-odds/group-a',
            'en-ca/sports-betting/football/world-cup/group-odds/group-b',
            'en-ca/sports-betting/football/world-cup/group-odds/group-c',
            'en-ca/sports-betting/football/world-cup/group-odds/group-d',
            'en-ca/sports-betting/football/world-cup/group-odds/group-e',
            'en-ca/sports-betting/football/world-cup/group-odds/group-f',
            'en-ca/sports-betting/football/world-cup/group-odds/group-g',
            'en-ca/sports-betting/football/world-cup/group-odds/group-h',
            'en-ca/sports-betting/football/world-cup/quarter-finals-odds',
            'en-ca/sports-betting/football/world-cup/round-of-16-odds',
            'en-ca/sports-betting/football/world-cup/semi-final-odds',
            'en-ca/sports-betting/football/world-cup/winner-odds',
            'en-ca/sports-betting/march-madness',
            'en-ca/sports-betting/superbowl',
            'en-ca/sports-betting/tennis',
            'en-ca/sports-betting/virtual-sports',
            'en-ca/sports-terms-and-conditions',
            'en-ca/sports-test',
            'en-ca/sports-wo-test',
            'en-gb/l/aff/sports',
            'en-gb/l/sports-betting',
            'en-gb/l/sports-betting-b',
            'en-gb/sports-betting',
            'en-gb/sports-betting/boxing',
            'en-gb/sports-betting/championship',
            'en-gb/sports-betting/football/world-cup',
            'en-gb/sports-betting/football/world-cup/final-odds',
            'en-gb/sports-betting/football/world-cup/golden-ball-odds',
            'en-gb/sports-betting/football/world-cup/golden-boot-odds',
            'en-gb/sports-betting/football/world-cup/golden-glove-odds',
            'en-gb/sports-betting/football/world-cup/group-odds',
            'en-gb/sports-betting/football/world-cup/group-odds/group-a',
            'en-gb/sports-betting/football/world-cup/group-odds/group-b',
            'en-gb/sports-betting/football/world-cup/group-odds/group-c',
            'en-gb/sports-betting/football/world-cup/group-odds/group-d',
            'en-gb/sports-betting/football/world-cup/group-odds/group-e',
            'en-gb/sports-betting/football/world-cup/group-odds/group-f',
            'en-gb/sports-betting/football/world-cup/group-odds/group-g',
            'en-gb/sports-betting/football/world-cup/group-odds/group-h',
            'en-gb/sports-betting/football/world-cup/quarter-finals-odds',
            'en-gb/sports-betting/football/world-cup/round-of-16-odds',
            'en-gb/sports-betting/football/world-cup/semi-final-odds',
            'en-gb/sports-betting/football/world-cup/winner-odds',
            'en-gb/sports-betting/horse-racing',
            'en-gb/sports-betting/odds-boost',
            'en-gb/sports-betting/rugby-betting',
            'en-gb/sports-betting/serie-a',
            'en-gb/sports-betting/tennis-betting',
            'en-gb/sports-betting/virtual-sports',
            'en-gb/sports-terms-and-conditions',
            'en-gb/sports-wo-test',
            'en-nz/l/aff/sports',
            'en-nz/sports-betting',
            'en-nz/sports-betting/boxing',
            'en-nz/sports-terms-and-conditions',
            'en-nz/sports-welcome-offer',
            'en-nz/sports-wo-test',
            'en/sports-betting/boxing',
            'es/l/aff/sports',
            'es/l/aff/sports-offer',
            'es/l/sports-betting',
            'es/sports-betting/boxing',
            'es/sports-wo-test',
            'fi/l/aff/sports',
            'fi/sports-terms-and-conditions',
            'ie/l/aff/sports',
            'ie/sports-betting',
            'ie/sports-betting/football',
            'ie/sports-betting/football/world-cup',
            'ie/sports-betting/football/world-cup/golden-ball-odds',
            'ie/sports-betting/football/world-cup/golden-boot-odds',
            'ie/sports-betting/football/world-cup/golden-glove-odds',
            'ie/sports-betting/football/world-cup/group-odds',
            'ie/sports-betting/football/world-cup/group-odds/group-a',
            'ie/sports-betting/football/world-cup/group-odds/group-b',
            'ie/sports-betting/football/world-cup/group-odds/group-c',
            'ie/sports-betting/football/world-cup/group-odds/group-d',
            'ie/sports-betting/football/world-cup/group-odds/group-e',
            'ie/sports-betting/football/world-cup/group-odds/group-f',
            'ie/sports-betting/football/world-cup/group-odds/group-g',
            'ie/sports-betting/football/world-cup/group-odds/group-h',
            'ie/sports-betting/football/world-cup/quarter-finals-odds',
            'ie/sports-betting/football/world-cup/round-of-16-odds',
            'ie/sports-betting/football/world-cup/semi-final-odds',
            'ie/sports-betting/football/world-cup/winner-odds',
            'ie/sports-betting/horse-racing',
            'ie/sports-betting/rugby-betting',
            'ie/sports-betting/serie-a',
            'ie/sports-betting/superbowl',
            'ie/sports-terms-and-conditions',
            'ie/sports-wo-test',
            'no/sports-betting/boxing',
            'no/sports-terms-and-conditions',
            'no/sports-wo-test',
            'on/l/aff/sports',
            'on/l/aff/sports/top-10-casinos',
            'on/sports-betting/football/world-cup/golden-boot-odds',
            'on/sports-betting/football/world-cup/golden-glove-odds',
            'on/sports-betting/football/world-cup/group-odds',
            'on/sports-betting/football/world-cup/group-odds/group-a',
            'on/sports-betting/football/world-cup/group-odds/group-b',
            'on/sports-betting/football/world-cup/group-odds/group-d',
            'on/sports-betting/football/world-cup/group-odds/group-e',
            'on/sports-betting/football/world-cup/group-odds/group-f',
            'on/sports-betting/football/world-cup/semi-final-odds',
            'on/sports-terms-and-conditions',
            'sv/l/aff/sports',
            'sv/l/aff/sports/gentoo',
            'sv/sports-betting/boxing',
            'sv/sports-terms-and-conditions',
            'sv/sports-wo-test'
        ]),
        slugified: [
            ['en-ca/sports/(.*)?', pathToRegexp('en-ca/sports/(.*)?')],
            ['en-ca/test-sports(.*)', pathToRegexp('en-ca/test-sports(.*)')],
            ['en-gb/sports/(.*)?', pathToRegexp('en-gb/sports/(.*)?')],
            ['en-gb/test-sports(.*)', pathToRegexp('en-gb/test-sports(.*)')],
            ['en-nz/sports/(.*)?', pathToRegexp('en-nz/sports/(.*)?')],
            ['es/sports/(.*)?', pathToRegexp('es/sports/(.*)?')],
            ['fi/sports/(.*)?', pathToRegexp('fi/sports/(.*)?')],
            ['ie/sports/(.*)?', pathToRegexp('ie/sports/(.*)?')],
            ['no/sports/(.*)?', pathToRegexp('no/sports/(.*)?')],
            ['on/sports/(.*)?', pathToRegexp('on/sports/(.*)?')],
            ['sv/sports/(.*)?', pathToRegexp('sv/sports/(.*)?')]
        ]
    },
    '(content)/(wallet-hub)': {
        default: new Set<string>([
            'en-ca/cash/deposit',
            'en-ca/cash/history',
            'en-ca/cash/history/bets',
            'en-ca/cash/withdraw',
            'en-gb/cash/deposit',
            'en-gb/cash/history',
            'en-gb/cash/history/bets',
            'en-gb/cash/withdraw',
            'en-nz/cash/deposit',
            'en-nz/cash/history',
            'en-nz/cash/history/bets',
            'en-nz/cash/withdraw',
            'en/cash/deposit',
            'en/cash/history',
            'en/cash/history/bets',
            'en/cash/withdraw',
            'es/cash/deposit',
            'es/cash/history',
            'es/cash/history/bets',
            'es/cash/withdraw',
            'fi/cash/deposit',
            'fi/cash/history',
            'fi/cash/history/bets',
            'fi/cash/withdraw',
            'ie/cash/deposit',
            'ie/cash/history',
            'ie/cash/history/bets',
            'ie/cash/withdraw',
            'no/cash/deposit',
            'no/cash/history',
            'no/cash/history/bets',
            'no/cash/withdraw',
            'on/cash/deposit',
            'on/cash/history',
            'on/cash/history/bets',
            'on/cash/withdraw',
            'sv/cash/deposit',
            'sv/cash/history',
            'sv/cash/history/bets',
            'sv/cash/withdraw'
        ]),
        slugified: []
    },
    '(noshell)': {
        default: new Set<string>([
            'en-ca/100k-terms-embedded',
            'en-ca/bonus-terms-2',
            'en-ca/bonus-terms-embedded',
            'en-ca/bonus-terms-embedded-uk',
            'en-ca/casino-games/best-games',
            'en-ca/casino-games/the-lioness',
            'en-ca/jackpot-blizzard-bonus-terms-embedded',
            'en-ca/jumioError',
            'en-ca/jumioSuccess',
            'en-ca/perf-test-page',
            'en-ca/privacy-notice-2',
            'en-ca/sports-bonus-terms',
            'en-ca/sports-terms-and-conditions-2',
            'en-ca/terms-and-conditions-2',
            'en-ca/wo-terms-embedded',
            'en-gb/100k-terms-embedded',
            'en-gb/bonus-terms-2',
            'en-gb/bonus-terms-embedded',
            'en-gb/bonus-terms-embedded-uk',
            'en-gb/casino-games/best-games',
            'en-gb/casino-games/crazy-coin-flip',
            'en-gb/casino-games/gold-bar-roulette',
            'en-gb/jackpot-blizzard-bonus-terms-embedded',
            'en-gb/jumioError',
            'en-gb/jumioSuccess',
            'en-gb/perf-test-page',
            'en-gb/privacy-notice-2',
            'en-gb/sports-bonus-terms',
            'en-gb/sports-terms-and-conditions-2',
            'en-gb/terms-and-conditions-2',
            'en-gb/wo-terms-embedded',
            'en-nz/100k-terms-embedded',
            'en-nz/bonus-terms-2',
            'en-nz/bonus-terms-embedded',
            'en-nz/bonus-terms-embedded-uk',
            'en-nz/casino-games/best-games',
            'en-nz/casino-games/crazy-coin-flip',
            'en-nz/casino-games/the-lioness',
            'en-nz/games/gold-bar-roulette',
            'en-nz/jackpot-blizzard-bonus-terms-embedded',
            'en-nz/jumioError',
            'en-nz/jumioSuccess',
            'en-nz/perf-test-page',
            'en-nz/privacy-notice-2',
            'en-nz/sports-bonus-terms',
            'en-nz/sports-terms-and-conditions-2',
            'en-nz/terms-and-conditions-2',
            'en-nz/wo-terms-embedded',
            'en/100k-terms-embedded',
            'en/bonus-terms-2',
            'en/bonus-terms-embedded',
            'en/bonus-terms-embedded-uk',
            'en/casino-games/best-games',
            'en/casino-games/crazy-coin-flip',
            'en/casino-games/gold-bar-roulette',
            'en/jackpot-blizzard-bonus-terms-embedded',
            'en/jumioError',
            'en/jumioSuccess',
            'en/perf-test-page',
            'en/privacy-notice-2',
            'en/removeme-dev-test',
            'en/sports-bonus-terms',
            'en/terms-and-conditions-2',
            'en/wo-terms-embedded',
            'es/aviso-privacidad-2',
            'es/bonus-terms-2',
            'es/bonus-terms-embedded',
            'es/bonus-terms-embedded-uk',
            'es/jackpot-blizzard-bonus-terms-embedded',
            'es/juegos-casino/mejores-juegos',
            'es/jumioError',
            'es/jumioSuccess',
            'es/perf-test-page',
            'es/sports-bonus-terms',
            'es/sports-terms-and-conditions-2',
            'es/terminos-y-condiciones-2',
            'es/wo-terms-embedded',
            'fi/100k-terms-embedded',
            'fi/bonus-terms-2',
            'fi/bonus-terms-embedded',
            'fi/bonus-terms-embedded-uk',
            'fi/jackpot-blizzard-bonus-terms-embedded',
            'fi/jumioError',
            'fi/jumioSuccess',
            'fi/perf-test-page',
            'fi/terms-and-conditions-2',
            'fi/tietosuojailmoitus-2',
            'fi/wo-terms-embedded',
            'ie/100k-terms-embedded',
            'ie/bonus-terms-2',
            'ie/bonus-terms-embedded',
            'ie/bonus-terms-embedded-uk',
            'ie/casino-games/best-games',
            'ie/casino-games/crazy-coin-flip',
            'ie/casino-games/gold-bar-roulette',
            'ie/jackpot-blizzard-bonus-terms-embedded',
            'ie/jumioError',
            'ie/jumioSuccess',
            'ie/perf-test-page',
            'ie/privacy-notice-2',
            'ie/sports-bonus-terms',
            'ie/sports-terms-and-conditions-2',
            'ie/terms-and-conditions-2',
            'ie/wo-terms-embedded',
            'no/100k-terms-embedded',
            'no/bonus-terms-2',
            'no/bonus-terms-embedded',
            'no/bonus-terms-embedded-uk',
            'no/casinospill/beste-spill',
            'no/casinospill/crazy-coin-flip',
            'no/casinospill/gold-bar-roulette',
            'no/jackpot-blizzard-bonus-terms-embedded',
            'no/jumioError',
            'no/jumioSuccess',
            'no/perf-test-page',
            'no/personvernerklaeringen-2',
            'no/sports-bonus-terms',
            'no/sports-terms-and-conditions-2',
            'no/terms-and-conditions-2',
            'no/wo-terms-embedded',
            'on/100k-terms-embedded',
            'on/bonus-terms-2',
            'on/bonus-terms-embedded',
            'on/bonus-terms-embedded-uk',
            'on/jackpot-blizzard-bonus-terms-embedded',
            'on/jumioError',
            'on/jumioSuccess',
            'on/privacy-notice-2',
            'on/sports-terms-and-conditions-2',
            'on/terms-and-conditions-2',
            'on/wo-terms-embedded',
            'rog/bonus-terms-2',
            'rog/bonus-terms-embedded',
            'rog/bonus-terms-embedded-uk',
            'rog/jackpot-blizzard-bonus-terms-embedded',
            'rog/jumioError',
            'rog/jumioSuccess',
            'rog/perf-test-page',
            'rog/privacy-notice-2',
            'rog/sports-bonus-terms',
            'rog/terms-and-conditions-2',
            'rog/wo-terms-embedded',
            'row/100k-terms-embedded',
            'row/bonus-terms-2',
            'row/bonus-terms-embedded',
            'row/bonus-terms-embedded-uk',
            'row/casino-games/best-games',
            'row/casino-games/crazy-coin-flip',
            'row/casino-games/gold-bar-roulette',
            'row/jackpot-blizzard-bonus-terms-embedded',
            'row/jumioError',
            'row/jumioSuccess',
            'row/perf-test-page',
            'row/privacy-notice-2',
            'row/sports-bonus-terms',
            'row/terms-and-conditions-2',
            'row/wo-terms-embedded',
            'sv/bonus-terms-2',
            'sv/bonus-terms-embedded',
            'sv/bonus-terms-embedded-uk',
            'sv/casinospel/basta-kasinospel',
            'sv/casinospel/crazy-coin-flip',
            'sv/casinospel/gold-bar-roulette',
            'sv/casinospel/the-lioness',
            'sv/integritetspolicy-2',
            'sv/jackpot-blizzard-bonus-terms-embedded',
            'sv/jumioError',
            'sv/jumioSuccess',
            'sv/native/bankid',
            'sv/perf-test-page',
            'sv/sports-bonus-terms',
            'sv/sports-terms-and-conditions-2',
            'sv/terms-and-conditions-2',
            'sv/wo-terms-embedded'
        ]),
        slugified: [
            [
                'en-ca/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('en-ca/gameInterfaces/iframe/:encodedURL')
            ],
            ['en-ca/migration/:token/:pid', pathToRegexp('en-ca/migration/:token/:pid')],
            ['en-ca/practise/:gameSlug', pathToRegexp('en-ca/practise/:gameSlug')],
            [
                'en-ca/promotion-terms/:promotionSlug',
                pathToRegexp('en-ca/promotion-terms/:promotionSlug')
            ],
            [
                'en-gb/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('en-gb/gameInterfaces/iframe/:encodedURL')
            ],
            ['en-gb/migration/:token/:pid', pathToRegexp('en-gb/migration/:token/:pid')],
            ['en-gb/practise/:gameSlug', pathToRegexp('en-gb/practise/:gameSlug')],
            [
                'en-gb/promotion-terms/:promotionSlug',
                pathToRegexp('en-gb/promotion-terms/:promotionSlug')
            ],
            [
                'en-nz/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('en-nz/gameInterfaces/iframe/:encodedURL')
            ],
            ['en-nz/migration/:token/:pid', pathToRegexp('en-nz/migration/:token/:pid')],
            ['en-nz/practise/:gameSlug', pathToRegexp('en-nz/practise/:gameSlug')],
            [
                'en-nz/promotion-terms/:promotionSlug',
                pathToRegexp('en-nz/promotion-terms/:promotionSlug')
            ],
            [
                'en/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('en/gameInterfaces/iframe/:encodedURL')
            ],
            ['en/migration/:token/:pid', pathToRegexp('en/migration/:token/:pid')],
            ['en/practise/:gameSlug', pathToRegexp('en/practise/:gameSlug')],
            [
                'en/promotion-terms/:promotionSlug',
                pathToRegexp('en/promotion-terms/:promotionSlug')
            ],
            ['en/schufacheck/:token/:pid', pathToRegexp('en/schufacheck/:token/:pid')],
            [
                'es/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('es/gameInterfaces/iframe/:encodedURL')
            ],
            ['es/migration/:token/:pid', pathToRegexp('es/migration/:token/:pid')],
            ['es/practise/:gameSlug', pathToRegexp('es/practise/:gameSlug')],
            [
                'es/promotion-terms/:promotionSlug',
                pathToRegexp('es/promotion-terms/:promotionSlug')
            ],
            [
                'fi/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('fi/gameInterfaces/iframe/:encodedURL')
            ],
            ['fi/migration/:token/:pid', pathToRegexp('fi/migration/:token/:pid')],
            ['fi/practise/:gameSlug', pathToRegexp('fi/practise/:gameSlug')],
            [
                'fi/promotion-terms/:promotionSlug',
                pathToRegexp('fi/promotion-terms/:promotionSlug')
            ],
            [
                'ie/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('ie/gameInterfaces/iframe/:encodedURL')
            ],
            ['ie/migration/:token/:pid', pathToRegexp('ie/migration/:token/:pid')],
            ['ie/practise/:gameSlug', pathToRegexp('ie/practise/:gameSlug')],
            [
                'ie/promotion-terms/:promotionSlug',
                pathToRegexp('ie/promotion-terms/:promotionSlug')
            ],
            [
                'no/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('no/gameInterfaces/iframe/:encodedURL')
            ],
            ['no/migration/:token/:pid', pathToRegexp('no/migration/:token/:pid')],
            ['no/practise/:gameSlug', pathToRegexp('no/practise/:gameSlug')],
            [
                'no/promotion-terms/:promotionSlug',
                pathToRegexp('no/promotion-terms/:promotionSlug')
            ],
            [
                'on/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('on/gameInterfaces/iframe/:encodedURL')
            ],
            ['on/migration/:token/:pid', pathToRegexp('on/migration/:token/:pid')],
            ['on/practise/:gameSlug', pathToRegexp('on/practise/:gameSlug')],
            [
                'on/promotion-terms/:promotionSlug',
                pathToRegexp('on/promotion-terms/:promotionSlug')
            ],
            [
                'rog/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('rog/gameInterfaces/iframe/:encodedURL')
            ],
            ['rog/migration/:token/:pid', pathToRegexp('rog/migration/:token/:pid')],
            ['rog/practise/:gameSlug', pathToRegexp('rog/practise/:gameSlug')],
            [
                'rog/promotion-terms/:promotionSlug',
                pathToRegexp('rog/promotion-terms/:promotionSlug')
            ],
            [
                'row/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('row/gameInterfaces/iframe/:encodedURL')
            ],
            ['row/migration/:token/:pid', pathToRegexp('row/migration/:token/:pid')],
            ['row/practise/:gameSlug', pathToRegexp('row/practise/:gameSlug')],
            [
                'row/promotion-terms/:promotionSlug',
                pathToRegexp('row/promotion-terms/:promotionSlug')
            ],
            ['row/schufacheck/:token/:pid', pathToRegexp('row/schufacheck/:token/:pid')],
            [
                'sv/gameInterfaces/iframe/:encodedURL',
                pathToRegexp('sv/gameInterfaces/iframe/:encodedURL')
            ],
            ['sv/migration/:token/:pid', pathToRegexp('sv/migration/:token/:pid')],
            ['sv/practise/:gameSlug', pathToRegexp('sv/practise/:gameSlug')],
            ['sv/promotion-terms/:promotionSlug', pathToRegexp('sv/promotion-terms/:promotionSlug')]
        ]
    },
    '(noshell)/(payments)': {
        default: new Set<string>([
            'en-ca/jc-pay-and-play',
            'en-ca/jc-redirection-callback',
            'en-gb/jc-pay-and-play',
            'en-gb/jc-redirection-callback',
            'en-nz/jc-pay-and-play',
            'en-nz/jc-redirection-callback',
            'en/jc-pay-and-play',
            'en/jc-redirection-callback',
            'es/jc-pay-and-play',
            'es/jc-redirection-callback',
            'fi/jc-pay-and-play',
            'fi/jc-redirection-callback',
            'ie/jc-pay-and-play',
            'ie/jc-redirection-callback',
            'no/jc-pay-and-play',
            'no/jc-redirection-callback',
            'on/jc-pay-and-play',
            'on/jc-redirection-callback',
            'sv/jc-pay-and-play',
            'sv/jc-redirection-callback'
        ]),
        slugified: []
    },
    '(noshell)/(play-games)': {
        default: new Set<string>([]),
        slugified: []
    }
});
